// components/doctors/DoctorAvailability.jsx
import React from 'react';

const DoctorAvailability = ({ availability, workingHours }) => {
  // If availability is not an array (like in some API responses), convert it
  const availableDays = Array.isArray(availability) ? availability : 
                       (typeof availability === 'string' ? availability.split(',') : []);

  // Sort days in week order for better presentation
  const dayOrder = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
  const sortedDays = availableDays.sort((a, b) => 
    dayOrder.indexOf(a) - dayOrder.indexOf(b)
  );

  return (
    <div className="space-y-1">
      {sortedDays.map(day => {
        const hours = workingHours?.[day];
        return (
          <div key={day} className="flex justify-between text-sm">
            <span className="font-medium text-gray-700">{day}:</span>
            {hours ? (
              <span className="text-gray-600">
                {hours.start} - {hours.end}
              </span>
            ) : (
              <span className="text-gray-400">Not available</span>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default DoctorAvailability;